var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_150164",
    "data-name": "Group 150164",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_102653",
    "data-name": "Path 102653",
    d: "M195.57,352a4.576,4.576,0,0,0-4.57,4.57v6.68h9.141v-6.68A4.576,4.576,0,0,0,195.57,352Z",
    transform: "translate(-177.57 -327.25)",
    fill: "#284261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102654",
    "data-name": "Path 102654",
    d: "M64.59,261a7.369,7.369,0,0,1-8.473,0,7.369,7.369,0,0,1-8.473,0,7.379,7.379,0,0,1-6.645.933v15.661a1.055,1.055,0,0,0,1.055,1.055h7.383v-6.68a6.68,6.68,0,0,1,13.359,0v6.68H70.18a1.055,1.055,0,0,0,1.055-1.055V261.933A7.379,7.379,0,0,1,64.59,261Z",
    transform: "translate(-38.117 -242.648)",
    fill: "#284261"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102655",
    "data-name": "Path 102655",
    d: "M0,9.141v3.146a5.289,5.289,0,0,0,9.527,3.164,5.285,5.285,0,0,0,8.473,0,5.285,5.285,0,0,0,8.473,0A5.289,5.289,0,0,0,36,12.287V9.141ZM32.373.583A1.055,1.055,0,0,0,31.43,0H4.57a1.055,1.055,0,0,0-.944.583L.4,7.031H35.6Z",
    fill: "#284261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/Retail.28b32079f4a4d878640f4e6537397395.svg";
export { ForwardRef as ReactComponent };